/**
 * WCAG contrast ratio, used to warn a shop when a colour pair it has chosen
 * would be hard to read on the customer form.
 *
 * Only handles hex — that is what a colour input produces, and the only format
 * the picker writes.
 */

function toRgb(hex) {
  const value = String(hex || '').trim().replace('#', '');
  const full = value.length === 3
    ? value.split('').map((char) => char + char).join('')
    : value;

  if (!/^[0-9a-f]{6}$/i.test(full)) return null;

  return [0, 2, 4].map((offset) => parseInt(full.slice(offset, offset + 2), 16));
}

function relativeLuminance(rgb) {
  const [r, g, b] = rgb.map((channel) => {
    const c = channel / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/** @returns {number|null} ratio from 1 to 21, or null if either colour is unreadable */
export function contrastRatio(foreground, background) {
  const fg = toRgb(foreground);
  const bg = toRgb(background);
  if (!fg || !bg) return null;

  const lighter = Math.max(relativeLuminance(fg), relativeLuminance(bg));
  const darker = Math.min(relativeLuminance(fg), relativeLuminance(bg));

  return (lighter + 0.05) / (darker + 0.05);
}

/** WCAG AA for body text. */
export function meetsAA(foreground, background) {
  const ratio = contrastRatio(foreground, background);
  return ratio === null || ratio >= 4.5;
}
